import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { formatDateDMY } from '../../utils/dateUtils';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const StatementHistoryDialog = ({ apt, onClose }) => {
  const [rows, setRows] = useState(null);
  useEffect(() => {
    if (!apt) return;
    setRows(null);
    axios.get(`${API}/apartments/${apt.apartment_id}/statement-history`, { withCredentials: true })
      .then((r) => setRows(r.data || [])).catch(() => setRows([]));
  }, [apt]);
  return (
    <Dialog open={!!apt} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-2xl" data-testid="statement-history-modal">
        <DialogHeader>
          <DialogTitle>Ιστορικό Αποστολών</DialogTitle>
          {apt && <p className="text-xs text-zinc-500">{apt.building_name} · Διαμέρισμα {apt.apartment_number} · {apt.owner_name || '—'}</p>}
        </DialogHeader>
        <div className="max-h-[60vh] overflow-y-auto">
          {rows === null ? <p className="text-center text-zinc-400 text-sm py-6">Φόρτωση…</p> : rows.length === 0 ? (
            <p className="text-center text-zinc-400 text-sm py-6" data-testid="statement-history-empty">Δεν έχει σταλεί ποτέ</p>
          ) : (
            <table className="w-full text-xs">
              <thead className="bg-zinc-50 text-[10px] uppercase tracking-wider text-zinc-600 text-left">
                <tr><th className="px-3 py-2">Ημ/νία Αποστολής</th><th className="px-2 py-2">Θέμα</th><th className="px-2 py-2">Προς</th></tr>
              </thead>
              <tbody className="divide-y divide-zinc-100">
                {rows.map((r) => (
                  <tr key={r.log_id} data-testid={`stmt-history-row-${r.log_id}`}>
                    <td className="px-3 py-1.5 font-mono whitespace-nowrap">{r.sent_at ? formatDateDMY(String(r.sent_at).slice(0, 10)) : '—'}</td>
                    <td className="px-2 py-1.5 truncate max-w-[260px]" title={r.subject}>{r.subject || '—'}</td>
                    <td className="px-2 py-1.5 truncate max-w-[200px]">{r.to_email || '—'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};
